export class CreateOpportunity {
    businessTypeId?: number;
    campaignId?: string;
    contactOriginTypeId?: string;
    date?: Date;
    entityId?: string;
    files?: Array<any>;
    internalReferenceId?: number;
    leadId?: string;
    note?: any;
    originEntityId?: string;
    originSupplierId?: number;
    salesmanId?: number;
    preferentialLoyaltyPeriodMonths?: number;

    constructor(
        businessTypeId?: number,
        campaignId?: string,
        contactOriginTypeId?: string,
        date?: Date,
        entityId?: string,
        files?: Array<any>,
        internalReferenceId?: number,
        leadId?: string,
        note?: any,
        originEntityId?: string,
        originSupplierId?: number,
        salesmanId?: number,
        preferentialLoyaltyPeriodMonths?: number
    ) {
        this.businessTypeId = businessTypeId;
        this.campaignId = campaignId;
        this.contactOriginTypeId = contactOriginTypeId;
        this.date = date;
        this.entityId = entityId;
        this.files = files;
        this.internalReferenceId = internalReferenceId;
        this.leadId = leadId;
        this.note = note;
        this.originEntityId = originEntityId;
        this.originSupplierId = originSupplierId;
        this.salesmanId = salesmanId;
        this.preferentialLoyaltyPeriodMonths = preferentialLoyaltyPeriodMonths;
    }
}


export class CreateEnergyOpportunityElectricityMeters {
    electricityMeterId?: number;
    estimatedAnnualConsumptionsDate?: Date | string;
    offPeakEstimatedAnnualConsumption?: number;
    offPeakEnergyPrice?: number;
    peakEstimatedAnnualConsumption?: number;
    peakEnergyPrice?: number;
    standardEstimatedAnnualConsumption?: number;
    standardEnergyPrice?: number;
    superOffPeakEstimatedAnnualConsumption?: number;
    superOffPeakEnergyPrice?: number;

    constructor(
        electricityMeterId?: number,
        estimatedAnnualConsumptionsDate?: Date | string,
        offPeakEstimatedAnnualConsumption?: number,
        offPeakEnergyPrice?: number,
        peakEstimatedAnnualConsumption?: number,
        peakEnergyPrice?: number,
        standardEstimatedAnnualConsumption?: number,
        standardEnergyPrice?: number,
        superOffPeakEstimatedAnnualConsumption?: number,
        superOffPeakEnergyPrice?: number
    ) {
        this.electricityMeterId = electricityMeterId;
        this.estimatedAnnualConsumptionsDate = estimatedAnnualConsumptionsDate;
        this.offPeakEstimatedAnnualConsumption = offPeakEstimatedAnnualConsumption;
        this.offPeakEnergyPrice = offPeakEnergyPrice;
        this.peakEstimatedAnnualConsumption = peakEstimatedAnnualConsumption;
        this.peakEnergyPrice = peakEnergyPrice;
        this.standardEstimatedAnnualConsumption = standardEstimatedAnnualConsumption;
        this.standardEnergyPrice = standardEnergyPrice;
        this.superOffPeakEstimatedAnnualConsumption = superOffPeakEstimatedAnnualConsumption;
        this.superOffPeakEnergyPrice = superOffPeakEnergyPrice;
    }
}

export class CreateEnergyOpportunityNaturalGasMeters {
    naturalGasMeterId?: number;
    estimatedAnnualConsumption?: number;
    estimatedAnnualConsumptionDate?: Date;
    energyPrice?: number;

    constructor(
        naturalGasMeterId?: number,
        estimatedAnnualConsumption?: number,
        energyPrice?: number
    ) {
        this.naturalGasMeterId = naturalGasMeterId;
        this.estimatedAnnualConsumption = estimatedAnnualConsumption;
        this.energyPrice = energyPrice;
    }
}